import { fetchLeads } from "../store/slices/leadsSlice";
import { fetchEmployees } from "../store/slices/employeeSlice";
import { fetchServiceTypes } from "../store/slices/serviceTypesSlice";
import { fetchLeadTypes } from "../store/slices/leadTypeSlice";
import { fetchStatus } from "../store/slices/statusSlice";
import { fetchSources } from "../store/slices/sourceSlice";
import { fetchGroups } from "../store/slices/groupSlice";
import { fetchTaxes } from "../store/slices/taxSlice";
import { fetchFinancialData } from "../store/slices/financialSlice";
import { fetchRoles } from "../store/slices/roleSlice";
import { fetchEmployeeGroups } from "../store/slices/employeeGroup";
import { fetchQuotations } from "../store/slices/hourlyRates";
import { fetchOtherExpenses } from "../store/slices/otherexpenses";
import { fetchSalesTaxes } from "../store/slices/salesTaxesSlice";
import {
  fetchDescriptionTasks,
  fetchDescriptionTasksProjectTracking,
} from "../store/slices/DescriptionTask";
import { fetchHardware } from "../store/slices/hardwareStoreSlice";
import { fetchCompanyProfiles } from "../store/slices/companyProfileSlice";
import { fetchAllQuotationTemplates } from "../store/slices/QuotationTemplateSlice";
import { fetchAllQuotations } from "../store/slices/generateQuotationSlice";
import {
  fetchWorkEntries,
  fetchWorkEntriesProjectTracking,
} from "../store/slices/workentriesSlice";
import {
  fetchHardwareDescriptions,
  fetchHardwareProjectTracking,
} from "../store/slices/hardwareDescriptionSlice";
import { getAllAutoSaveWorkentries } from "../store/slices/autosaveSlice";
import { getAllFiles } from "../store/slices/FileDataSlice";
import { fetchAllProjects } from "../store/slices/projectsSlice";
import { fetchAllOngoingTasks } from "../store/slices/ProjectOngoingTask";
import { getMyTrainings } from "../store/slices/MyTraining/myTrainings";
import { fetchNotifications } from "../store/slices/NotificationSlices";
import { getInventoryByCreatedBy } from "../store/slices/InventorySlice";
import { getAllAssemblyInventory } from "../store/slices/assemblyInventorySlice";
import { getAllPartsInventory } from "../store/slices/partsInventorySlice";
import { fetchSalesHourlyRates } from "../store/slices/salesHourlyRateSlice";
import { fetchClients } from "../store/slices/clientDetailsSlice";
import { fetchSavedClientRatingAll } from "../store/slices/clientRatingDashboardSliceL3";

/**
 * Central module -> dispatch handlers.
 * Keep only lightweight, idempotent refresh handlers here.
 */
export const realtimeModuleHandlers = {
  leads: [() => fetchLeads()],
  employees: [() => fetchEmployees()],
  user: [() => fetchEmployees()],

  servicetypes: [() => fetchServiceTypes()],
  leadtypes: [() => fetchLeadTypes()],
  status: [() => fetchStatus()],
  source: [() => fetchSources()],
  groups: [() => fetchGroups()],
  taxes: [() => fetchTaxes()],
  financial: [() => fetchFinancialData()],
  roles: [() => fetchRoles()],
  managerprojectrequested: [
    () => fetchAllProjects(),
    () => fetchWorkEntriesProjectTracking(),
    () => fetchDescriptionTasksProjectTracking(),
    () => fetchHardwareProjectTracking(),
  ],
  employeegroup: [() => fetchEmployeeGroups()],
  hourlyratequotation: [() => fetchQuotations()],
  otherexpenses: [() => fetchOtherExpenses()],
  salestaxes: [() => fetchSalesTaxes()],
  descriptiontask: [
    () => fetchDescriptionTasks(),
    () => fetchDescriptionTasksProjectTracking(),
    () => fetchAllProjects(),
  ],
  hardwaredatastore: [() => fetchHardware()],
  companyprofile: [() => fetchCompanyProfiles()],
  quotationtemplate: [() => fetchAllQuotationTemplates()],
  generatequotation: [() => fetchAllQuotations()],
  workentries: [
    () => fetchWorkEntries(),
    () => fetchWorkEntriesProjectTracking(),
    () => fetchAllProjects(),
  ],
  "hardware-description": [
    () => fetchHardwareDescriptions(),
    () => fetchHardwareProjectTracking(),
    () => fetchAllProjects(),
  ],
  autosavework: [
    () => getAllAutoSaveWorkentries(),
    () => fetchWorkEntriesProjectTracking(),
    () => fetchDescriptionTasksProjectTracking(),
    () => fetchHardwareProjectTracking(),
    () => fetchAllProjects(),
  ],
  /** Normalized module for submit-task / project-assigned / reassigned / projectaction (see socketListener MODULE_ALIASES). */
  tasks: [
    () => fetchAllOngoingTasks(),
    () => fetchAllProjects(),
    () => fetchWorkEntriesProjectTracking(),
    () => fetchDescriptionTasksProjectTracking(),
    () => fetchHardwareProjectTracking(),
  ],
  // workentries: [() => fetchWorkEntries()],
  // "hardware-description": [() => fetchHardwareDescriptions()],
  // autosavework: [() => getAllAutoSaveWorkentries()],
  // "submit-task": [() => fetchAllOngoingTasks()],
  upload: [() => getAllFiles()],
  files: [() => getAllFiles()],
  filedata: [() => getAllFiles()],
  project: [
    () => fetchAllProjects(),
    () => fetchWorkEntriesProjectTracking(),
    () => fetchDescriptionTasksProjectTracking(),
    () => fetchHardwareProjectTracking(),
  ],
  "my-training": [() => getMyTrainings()],
  notify: [() => fetchNotifications({})],
  inventorydata: [() => getInventoryByCreatedBy()],
  assemblyinventory: [() => getAllAssemblyInventory()],
  partsinventory: [() => getAllPartsInventory()],
  saleshourlyrate: [() => fetchSalesHourlyRates()],
  "client-details": [() => fetchClients()],
  dashboard: [() => fetchSavedClientRatingAll()],
  clientrating: [() => fetchSavedClientRatingAll()],
};

export const getRealtimeHandlers = (moduleName) => {
  const key = `${moduleName || ""}`.toLowerCase().trim();
  if (!key) return [];
  return realtimeModuleHandlers[key] || [];
};
